module.exports = __webpack_public_path__ + "img/image 12.6602c9b9.png";